import { useState } from 'react';
import { X } from 'lucide-react';
import { getMobileOS, storeUrlFor } from '../constants/app';
import styles from './AppInstallStrip.module.css';

const DISMISS_KEY = 'dait_install_strip_dismissed';

function wasDismissed() {
  try { return localStorage.getItem(DISMISS_KEY) === '1'; }
  catch { return false; }
}

/**
 * 모바일 전용 상단 설치 스트립.
 * 콘텐츠를 밀어내지 않도록 한 줄로 두고, 닫으면 기억한다.
 * 데스크톱에서는 스토어 링크로 설치가 불가능하므로 아예 렌더하지 않는다(대신 홈의 QR 배너).
 */
export default function AppInstallStrip() {
  const [os] = useState(getMobileOS);
  const [hidden, setHidden] = useState(wasDismissed);

  const href = storeUrlFor(os);
  if (!href || hidden) return null;

  const dismiss = () => {
    setHidden(true);
    try { localStorage.setItem(DISMISS_KEY, '1'); } catch { /* 사파리 프라이빗 등 */ }
  };

  return (
    <div className={styles.strip}>
      <img className={styles.icon} src="/daeat_32x32.png" alt="" width="32" height="32" />
      <div className={styles.text}>
        <p className={styles.title}>다잇 앱</p>
        <p className={styles.sub}>앱에서 더 편하게 체험단을 확인하세요</p>
      </div>
      <a className={styles.cta} href={href} target="_blank" rel="noopener noreferrer">받기</a>
      <button className={styles.close} onClick={dismiss} aria-label="배너 닫기">
        <X size={16} strokeWidth={2.5} />
      </button>
    </div>
  );
}
